// export const API_BASE_URL = "http://192.168.29.17:5200/api/v1/";
// export const API_BASE_URL = "https://bibleapi.iosx.in/api/v1/";
export const API_BASE_URL = "https://adminapi.theholybible.life/api/v1/";
